module.exports = __webpack_public_path__ + "img/reserve-shop.91602ab3.png";